import { render, staticRenderFns } from "./index.vue?vue&type=template&id=63fc3b59&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fc3b59",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\newWarehouse\\qmsk-platform-supply-merchant-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63fc3b59')) {
      api.createRecord('63fc3b59', component.options)
    } else {
      api.reload('63fc3b59', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=63fc3b59&scoped=true", function () {
      api.rerender('63fc3b59', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/echartsNew/index.vue"
export default component.exports